import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";
import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

import { Context, variant } from "../../context";
import { useContext } from "react";

export const madeToOrder = async (data) => {
  try {
    const res = await postData(`/form/made-to-order`, data);

    return res;
  } catch (error) {
    console.error(error);
  }
};

export const RFQ = async (data) => {
  try {
    const res = await postData(`/form/rfq`, data);

    return res;
  } catch (error) {
    console.error(error);
  }
};

export const ContactUsForm = async (data) => {
  try {
    const res = await postData(`/finance/forms/contact-us`, data);

    return res;
  } catch (error) {
    console.error(error);
  }
};
export const FaqQueryForm = async (data) => {
  try {
    const res = await postData(`/finance/forms/contact-us/faq-query`, data);

    return res;
  } catch (error) {
    console.error(error);
  }
};
export const InsurencePurches = async (data) => {
  try {
    const res = await postData(`/finance/forms/insurance-purchase`, data);

    return res;
  } catch (error) {
    console.error(error);
  }
};

export const LoanForm = async (data) => {
  try {
    const res = await postData(`/finance/forms/loan-form`, data);

    return res;
  } catch (error) {
    console.error(error);
  }
};

export const LoanFormUpdate = async (data,id) => {
  try {
    const res = await postData(`/finance/forms/loan-form/${id}`, data);

    return res;
  } catch (error) {
    console.error(error);
  }
};


export const LoanFormGet = async () => {
  try {
    const res = await getData(`/finance/forms/loan-form`);

    return res;
  } catch (error) {
    console.error(error);
  }
};


export const EnquiryForm = async (data) => {
  try {
    const res = await postData(`/finance/forms/inquiry-form`, data);

    return res;
  } catch (error) {
    console.error(error);
  }
};



export const Suggetion = async (data) => {
  try {
    const res = await postData(`/form/suggestion`, data);

    return res;
  } catch (error) {
    console.error(error);
  }
};
